<script setup>
import { ref } from "vue";
import { VAvatar } from "@astrocentro-webapp/ui/modules/commons/components/VAvatar";
import { VModal } from "@astrocentro-webapp/ui/modules/commons/components/VModal";

const open = ref(false);

const props = defineProps({
  variant: {
    type: String,
    default: "unavailable",
    validator(value) {
      return ["unavailable", "available", "busy"].includes(value);
    },
  },
  externalUrl: {
    type: String,
    default: "",
  },
  src: {
    type: String,
  },
  srcModal: {
    type: String,
  },
  size: {
    type: String,
    default: "sm",
  },
});

const variants = {
  unavailable: {
    class: "bg-soft-light",
    name: "offline",
  },
  available: {
    class: "bg-green",
    name: "online",
  },
  busy: {
    class: "bg-orange",
    name: "ocupado",
  },
};
</script>

<template>
  <div class="seller-avatar">
    <div :class="`position-relative avatar-${props.size} mx-auto mb-2`">
      <a
        :class="`d-block avatar-${props.size}`"
        :href="props.externalUrl ? props.externalUrl : null"
        v-if="props.externalUrl"
      >
        <VAvatar class="p-0 border border-3 border-white" :variant="props.size" :src="props.src" />
      </a>
      <VAvatar class="p-0 border border-3 border-white" :variant="props.size" :src="props.src" @click="open = true" v-else />
      <div
        :class="`status-dot border border-white ${props.size == 'lg' ? 'border-3' : 'border-1' } ${
          variants[props.variant].class
        } rounded-circle position-absolute`"
      ></div>
      <VModal :open="open" id="seller-video-modal" @modal-closed="open = false">
        <div class="modal-header border-bottom-0 pe-0">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="seller-video-modal"
            aria-label="Fechar"
            @click="open = false"
          ></button>
        </div>
        <div class="modal-body px-0">
          <img
            :src="props.srcModal"
          />
        </div>
      </VModal>
    </div>
    <slot :variants="variants"></slot>
  </div>
</template>

<style lang="scss" scoped>
/* VueCustomElementChildren */
@import "./SellerAvatar.scss";
</style>
